import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=a4765eb6&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"
import style0 from "./order-list.vue?vue&type=style&index=0&id=a4765eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4765eb6",
  null
  
)

export default component.exports